// @flow
export const PROGRESS_BAR_THEME_API = {
  track: '',
  progress: '',
  label: ''
};
